<template>
  <svg class="svg-icon" aria-hidden="true" :style="style" @click="$emit('click')">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    // 颜色值
    color: {
      type: String,
      default: '#fff'
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    style() {
      return { '--color': this.color, width: this.width, height: this.height }
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1.1em;
  height: 1.1em;
  vertical-align: middle;
  margin: 0 0 2px;
  fill: currentColor;
  overflow: hidden;
  color: var(--color);
}
</style>



// WEBPACK FOOTER //
// src/components/svgIcon/index.vue